exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".barButton{float:left;width:6em;border:1px solid #000;background:#fff;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-7a4ecb80!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/F3dCanvas.vue
// module id = 19
// module chunks = 0